import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
@Component({
  components: {
  },
})
export default class SpeedPopup extends Vue {
  @Prop({default: false}) visible: boolean
  @Prop() theme: string
  show = false
  speedList =  ['0.9','1.0','1.1','1.2','1.3','1.4','1.5','1.6','1.7','1.8','1.9','2.0'];
  selectedSpeed = '1.0'
  @Watch('visible')
  listenVisible(val) {
    this.show = val
  }
  chooseSpeed(item) {
    this.selectedSpeed = item
  }
  confirmSpeed() {
    this.$emit('confirmSpeed', this.selectedSpeed)
  }
  closePopup() {
    this.show = false
    this.$emit('close')
  }
}